import { DecarbonizationPillar } from "@labs/shared/types/Solution.ts";

export const pillarLabelMap = {
  [DecarbonizationPillar.EnergyEfficiency]: "Energy Efficiency",
  [DecarbonizationPillar.Electrification]: "Electrification",
  [DecarbonizationPillar.LowCarbonFuels]:
    "Low-carbon fuels, feedstocks, and energy sources",
  [DecarbonizationPillar.CarbonCapture]:
    "Carbon capture, utilization and storage",
};
